import * as Yup from "yup";

export const zipCodeValidation = Yup.string().matches(
  /^\d{5}$/,
  "Zip Code must be 5 digits"
);
